import { VueReCaptcha } from 'vue-recaptcha-v3'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  if (!config.public.recaptcha?.siteKey) {
    console.warn('Google ReCaptcha siteKey not defined - recaptcha will not work')
  }
  if (config.public.recaptcha?.siteKey) {
    const options = {
      siteKey: config.public.recaptcha.siteKey,
      loaderOptions: {
        autoHideBadge: true,
        useRecaptchaNet: true,
        renderParameters: {
          hl: 'id'
        }
      }
    }
    nuxtApp.vueApp.use(VueReCaptcha, options)
  }
})